//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import detailSubPage from '@/common/mixins/detailSubPage'
import { App_User } from '@/data/user_info'

import Loading from '@/components/views/loading'
import EmptyTip from '@/components/views/empty_tip'

import wxAPI from '@/utils/wx_api'

import CommentHeader from './_header'
import CommentItem from './_item'
import CommentFooter from './_footer'
import InputDlg from './_input_dlg'

import Data from './data'

import BuildingItem from '@/components/business/whole_building_item'

import { mapHouseItem } from '@/common/utils/map_view_data'

import CommentTip from '@/views/building/_components/comment_tip'
import add_comments from '@/common/mixins/addComments'
import pagination from '@/common/mixins/pagination'

import like_tip from '../mixins/likeTip'
import LikeTip from '../_components/_like_tip'
import SubscribeSuccess from '../_components/_subscribe_success'

export default {
    mixins: [
        add_comments,
        detailSubPage,
        pagination,
        like_tip,
    ],
    data () {
        return {
            per: 10,
            reply_item: {},
            reply_user: {},
            name: '',
            show_input_dlg: false,
            house: {
                photos_urls: []
            },
            house_loading: true,
            building_id: '',
            order_type: ''
        }
    },
    created () {
        const { name, building_id } = this.$route.query
        this.name = name || ''
        this.building_id = building_id
        this.getHouseData()
    },
    mounted () {
        if (Data.create_comment) {
            this.refresh()
        } else if (this.page === 1) {
            this.getData()
        }
        Data.create_comment = false
    },
    computed: {
        show_empty () {
            return this.items.length === 0 && !this.loading
        }
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            if (Data.create_comment) {
                vm.refresh()
            }
        })
    },
    methods: {
        refresh () {
            this.items = []
            this.page = 1
            this.getData()
            window.scrollTo(0, 0)
        },
        changeOrder (order_type) {
            this.order_type = order_type
            this.page = 1
            this.getData()
        },
        getData () {
            const { page } = this
            const { building_id, from_message_id } = this.$route.query
            this.loading = true
            const params = {
                from_message_id: from_message_id || '',
                page,
                per: this.per
            }
            if (this.order_type) {
                params.order_type = this.order_type
            }
            Service.getBuildingComments(building_id, params).then(this.handleData)
        },
        getHouseData () {
            const { building_id, from_message_id } = this.$route.query
            Service.getBuilding(building_id, from_message_id).then(( data ) => {
                data.favourite = data.follow_info && data.follow_info.id
                data.cover_photo_url = data.photos_urls && data.photos_urls.length ? data.photos_urls[0] : ''
                data.price_desc = ''
                data.surplus_houses_price = ''
                this.house = mapHouseItem(data)
                this.name = this.house.name
                this.house.href = `/building?building_id=${data.building_id}`
                console.error(this.house)
                this.house_loading = false
            })
        },
        openComment () {
            const { building_id } = this.$route.query
            this.$router.push({
                path: `/building/comments/add?building_id=${building_id}&name=${this.name}`
            })
        },
        async showInputDlg (index, reply_index) {
            if (await this.$checkUserLogging()) {
                console.error(index, reply_index)
                this.show_input_dlg = true
                this.reply_item = index && typeof Number(index) === 'number'  ? this.items[index] : {}
                this.reply_user = (reply_index && typeof Number(reply_index) === 'number') ? this.reply_item.reply_comments.items[reply_index] : {}
            }
        },
        hideInputDlg () {
            this.show_input_dlg = false
        },
        changeComment (comment, index) {
            const changed_item = this.items[index]
            if (comment.id === changed_item.id) {
                this.$set(this.items, index, comment)
            } else {
                this.items.some(({ id }, real_index) => {
                    if (id === comment.id) {
                        this.$set(this.items, real_index, comment)
                        return true
                    }
                })
            }
        },
        changeComments (data, reply_comment_id) {
            const { items: comments } = this
            this.hideInputDlg()
            if (reply_comment_id) {
                comments.some((comment, i) => {
                    if (comment.id === reply_comment_id) {
                        const { reply_comments } = comment
                        reply_comments.total_count += 1
                        reply_comments.items.unshift(data)
                        return true
                    }
                })
                this.items = comments
            } else {
                this.content = ''
                data.reply_comments = {
                    total_count: 0,
                    items: []
                }
                comments.unshift(data)
                this.items = comments
                wx.pageScrollTo && wx.pageScrollTo({
                    scrollTop: 0,
                    duration: 1500
                })
            }
        },
        changeFavourite () {
            this.toggleFavourite('楼盘评论页——关注')
            this.getHouseData()
        },
        addComment (comment_index, reply_index) {
            App_User.get().then((data) => {
                if (data.tag_list && data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    const { building_id } = this.$route.query
                    const comment = this.items[comment_index]
                    let reply_id = comment ? comment.id : ''
                    console.log('reply_index', reply_index)
                    if (reply_index && typeof Number(reply_index) === 'number') {
                        reply_id = comment.reply_comments.items[reply_index].id
                        console.log('reply_id', reply_id)
                    }
                    this.goAddComment(building_id, reply_id).then((can_comment) => {
                        if (can_comment) {
                            this.showInputDlg(comment_index, reply_index)
                        }
                    })
                }
            })
        }
    },
    components: {
        Loading,
        EmptyTip,
        CommentHeader,
        CommentItem,
        CommentFooter,
        InputDlg,
        BuildingItem,
        CommentTip,
        LikeTip,
        SubscribeSuccess
    }
}
